import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { useSettings } from 'hooks/useSettings';

type AppStateContextType = object;

export const AppStateContext = createContext<AppStateContextType>({} as any);

export function AppStateProvider({ children }: PropsWithChildren) {
  const contextData = useMemo<AppStateContextType>(() => ({}), []);

  return (
    <AppStateContext.Provider value={contextData}>
      {children}
    </AppStateContext.Provider>
  );
}
